import { render, staticRenderFns } from "./PrintOCRManagement.vue?vue&type=template&id=9b99b08c&scoped=true"
import script from "./PrintOCRManagement.vue?vue&type=script&lang=js"
export * from "./PrintOCRManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b99b08c",
  null
  
)

export default component.exports